// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Background: #0b0b0c
Iconography and buttons: #42bbd8
Title: #d1d0d1
Headers: #cccdcd
Text: #cdccca 
Card backgrounds: #161717

*/


.landing-page-container {
  max-width: 70vw;
  width: 90%;
  margin: 0 auto;
  /* background-color: #161717; */
  color: #cdccca;
  border-radius: 12px;
  /* box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08); */
  padding: 2.5rem 2rem;
  /* text-align: center; */
  text-align: left;
}

.landing-page-title {
  color: #d1d0d1;
  text-align: left;
  font-size: 2rem;
  margin: 0;
}

.landing-page-description {
  /* font-size: 1.2rem; */
  text-align: left;
  margin: 1.5rem 0 2rem 0;
  color: #cdccca;
}

.landing-page-image {
  width: 100%;
  max-width: 400px;
  border-radius: 10px;
  margin-bottom: 24px;
}

.landing-page-button-container {
  margin: 1rem;
}

.landing-page-button {
  background: #42bbd8;
  color: black;
  font-weight: bold;
  border: 0;
  white-space: normal;
  word-break: break-word;
  margin: 0 0.5rem;
  border-radius: 6px;
  padding: 1rem 2.5rem;
  font-size: 2rem;
  cursor: pointer;
}

.landing-page-link-button {
  display: block;
  background: #42bbd8;
  color: black;
  font-weight: bold;
  white-space: normal;
  word-break: break-word;
  margin: 1rem;
  border: 0;
  border-radius: 6px;
  padding: 1rem 2.5rem;
  font-size: 2rem;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
}

.landing-page-muted-text {
  margin-top: 8px;
  color: #aaa;
  font-size: 0.9rem;
}
/* 
.landing-page-iframe {
  width: 640px;
  height: 560px;
  border: 0;
  margin: 0;
} */

.landing-page-qr-code {
  border-radius: 10px;
  margin-bottom: 1rem;
  margin-left: 1rem;
}

/* .landing-page-features-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin: 32px 0;
}

@media (min-width: 600px),
@media (min-width: 800px),
@media (min-width: 1000px) {
  .landing-page-features-grid {
    grid-template-columns: 1fr !important;
  }
} */


.feature-card {
  background: #161717;
  border-radius: 16px;

  /* box-shadow: 0 12px 28px rgba(43,140,255,0.8); */
  padding: 24px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.2s;

  margin: 3rem;
}


.feature-card-image {
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin-bottom: 12px;
}

.feature-card-title {
  font-size: 1.15rem;
  font-weight: bold;
  margin-bottom: 8px;
}

.feature-card-type {
  font-size: 0.85rem;
  font-weight: bold;
  color: #42bbd8;
  margin-bottom: 8px;
  text-align: left;
}

.feature-card-description {
  font-size: 0.98rem;
  color: #aaa;
  margin-bottom: 16px;
}

.feature-card-button {
  background: #42bbd8;
  color: black;
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 2rem;
  cursor: pointer;
  transition: background 0.2s;
}
.feature-card-button:hover {
  background: #98daeb;
  color: black;
}

/* Responsive card row: stack vertically on small screens */
.feature-card-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
}

@media (max-width: 700px) {
  .feature-card-row {
    flex-direction: column !important;
    gap: 8px;
    align-items: stretch !important;
    justify-content: flex-start !important;
    width: 100%;
  }
  .feature-card-col {
    min-width: 0;
    width: 100% !important;
    padding: 0;
    align-items: center;
    justify-content: flex-start;
  }
  .feature-card-cover {
    margin-bottom: 10px;
    width: 100%;
    max-width: 100vw;
    min-width: 0;
  }
}

/* ===== Card cover: full-bleed image ===== */
.feature-card {
  overflow: hidden; /* ensures rounded corners clip the cover */
}

.feature-card-cover {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;              /* consistent height across cards */
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  margin-bottom: 14px;
  /* box-shadow: inset 0 0 0 1px rgba(0,0,0,0.04); */
}

/* Dark-to-transparent top overlay for legibility */
.feature-card-cover-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0,0,0,0.35) 0%,
    rgba(0,0,0,0.15) 40%,
    rgba(0,0,0,0.00) 100%
  );
  pointer-events: none;
  border-radius: 12px;
}

/* Small badge that reuses your emoji (from the title) */
.feature-card-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 1rem;
  background: rgba(255,255,255,0.85);
  color: #1f1f1f;
  border-radius: 999px;
  padding: 6px 10px;
  line-height: 1;
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.12); */
  backdrop-filter: saturate(140%) blur(6px);
}

/* Body spacing now that we have a cover */
.feature-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Optional tiny icon fallback (hidden by default on wide screens) */
.feature-card-image--fallback {
  width: 44px;
  height: 44px;
  object-fit: contain;
  margin: 2px 0 6px 0;
  opacity: 0.85;
  display: none; /* only show on narrow screens via media query if desired */
}

/* Sharper highlight treatment works great with cover */
.feature-card.highlight {
  /* box-shadow: 0 12px 28px rgba(246, 255, 0, 0.894); */
  /* border: 2px solid #2b8cff; */
  transform: translateY(-2px);
  transform: scale(1.03);
}

/* Hover polish (subtle lift & glow) */
.feature-card:hover {
  /* box-shadow: 0 12px 28px rgba(255, 255, 244, 0.894); */
  transform: translateY(-2px);
  transform: scale(1.03);
}

/* Tighter text for small screens + optional show fallback icon */
@media (max-width: 820px) {
  .feature-card-title { font-size: 1.05rem; }
  .feature-card-description { font-size: 0.94rem; }
  .feature-card-image--fallback { display: block; }
}

/* Ensure grid cards match height if lines wrap differently */
.landing-page-features-grid > .feature-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

/* Make cards and content fit small screens */
@media (max-width: 400px) {
  .landing-page-container {
    padding: 1rem 0.5rem;
    /* max-width: 100vw;
    width: 100vw; */
  }
  .feature-card {
    margin: 1rem 0.2rem;
    padding: 12px 4px;
    border-radius: 10px;
  }
  .feature-card-title {
    font-size: 1rem;
  }
  .feature-card-description {
    font-size: 0.85rem;
  }
  .feature-card-button {
    font-size: 1.2rem;
    padding: 6px 10px;
  }
  .feature-card-cover {
    aspect-ratio: 16 / 9;
    margin-bottom: 8px;
    border-radius: 8px;
    width: 100%;
    min-width: 0;
    /* max-width: 100vw; */
  }
  .feature-card-row {
    flex-direction: column;
    gap: 4px;
    align-items: stretch;
    width: 100%;
  }
  .feature-card-col {
    min-width: 0;
    width: 100%;
    padding: 0;
  }
  /* .landing-page-iframe {
    width: 98vw;
    height: 320px;
  } */
}

.landing-page-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;
}

.landing-page-col {
  flex: 1 1;
}
.landing-page-col.left {
  text-align: left;
}
.landing-page-col.right {
  text-align: right;
}

.landing-page-banner {
  width: 90%;
  max-width: 60vw;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  display: block;
  margin-left: auto;
  margin-right: 0;
}

@media (max-width: 700px) {
  .landing-page-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .landing-page-col.right {
    width: 100%;
    text-align: center;
    margin-top: 16px;
  }
  .landing-page-banner {
    width: 90%;
    max-width: 350px;
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/LandingPage.css"],"names":[],"mappings":"AAAA;;;;;;;;CAQC;;;AAGD;EACE,eAAe;EACf,UAAU;EACV,cAAc;EACd,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;EACnB,gDAAgD;EAChD,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;;;;;;GAMG;;AAEH;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;GAaG;;;AAGH;EACE,mBAAmB;EACnB,mBAAmB;;EAEnB,kDAAkD;EAClD,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;;EAE1B,YAAY;AACd;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,iCAAiC;IACjC,QAAQ;IACR,+BAA+B;IAC/B,sCAAsC;IACtC,WAAW;EACb;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,2BAA2B;EAC7B;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB,EAAE,2CAA2C;AAC/D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB,eAAe,mCAAmC;EACtE,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa,EAAE,2DAA2D;AAC5E;;AAEA,uDAAuD;AACvD;EACE,sDAAsD;EACtD,+BAA+B;EAC/B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,wDAAwD;EACxD,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,iEAAiE;AACjE;EACE,sBAAsB,kBAAkB,EAAE;EAC1C,4BAA4B,kBAAkB,EAAE;EAChD,gCAAgC,cAAc,EAAE;AAClD;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,6CAA6C;AAC7C;EACE;IACE,oBAAoB;IACpB;mBACe;EACjB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;EACA;;;KAGG;AACL;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,cAAc;EAChB;AACF","sourcesContent":["/*\nBackground: #0b0b0c\nIconography and buttons: #42bbd8\nTitle: #d1d0d1\nHeaders: #cccdcd\nText: #cdccca \nCard backgrounds: #161717\n\n*/\n\n\n.landing-page-container {\n  max-width: 70vw;\n  width: 90%;\n  margin: 0 auto;\n  /* background-color: #161717; */\n  color: #cdccca;\n  border-radius: 12px;\n  /* box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08); */\n  padding: 2.5rem 2rem;\n  /* text-align: center; */\n  text-align: left;\n}\n\n.landing-page-title {\n  color: #d1d0d1;\n  text-align: left;\n  font-size: 2rem;\n  margin: 0;\n}\n\n.landing-page-description {\n  /* font-size: 1.2rem; */\n  text-align: left;\n  margin: 1.5rem 0 2rem 0;\n  color: #cdccca;\n}\n\n.landing-page-image {\n  width: 100%;\n  max-width: 400px;\n  border-radius: 10px;\n  margin-bottom: 24px;\n}\n\n.landing-page-button-container {\n  margin: 1rem;\n}\n\n.landing-page-button {\n  background: #42bbd8;\n  color: black;\n  font-weight: bold;\n  border: 0;\n  white-space: normal;\n  word-break: break-word;\n  margin: 0 0.5rem;\n  border-radius: 6px;\n  padding: 1rem 2.5rem;\n  font-size: 2rem;\n  cursor: pointer;\n}\n\n.landing-page-link-button {\n  display: block;\n  background: #42bbd8;\n  color: black;\n  font-weight: bold;\n  white-space: normal;\n  word-break: break-word;\n  margin: 1rem;\n  border: 0;\n  border-radius: 6px;\n  padding: 1rem 2.5rem;\n  font-size: 2rem;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n}\n\n.landing-page-muted-text {\n  margin-top: 8px;\n  color: #aaa;\n  font-size: 0.9rem;\n}\n/* \n.landing-page-iframe {\n  width: 640px;\n  height: 560px;\n  border: 0;\n  margin: 0;\n} */\n\n.landing-page-qr-code {\n  border-radius: 10px;\n  margin-bottom: 1rem;\n  margin-left: 1rem;\n}\n\n/* .landing-page-features-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  margin: 32px 0;\n}\n\n@media (min-width: 600px),\n@media (min-width: 800px),\n@media (min-width: 1000px) {\n  .landing-page-features-grid {\n    grid-template-columns: 1fr !important;\n  }\n} */\n\n\n.feature-card {\n  background: #161717;\n  border-radius: 16px;\n\n  /* box-shadow: 0 12px 28px rgba(43,140,255,0.8); */\n  padding: 24px 16px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: transform 0.2s;\n\n  margin: 3rem;\n}\n\n\n.feature-card-image {\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n  margin-bottom: 12px;\n}\n\n.feature-card-title {\n  font-size: 1.15rem;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.feature-card-type {\n  font-size: 0.85rem;\n  font-weight: bold;\n  color: #42bbd8;\n  margin-bottom: 8px;\n  text-align: left;\n}\n\n.feature-card-description {\n  font-size: 0.98rem;\n  color: #aaa;\n  margin-bottom: 16px;\n}\n\n.feature-card-button {\n  background: #42bbd8;\n  color: black;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 18px;\n  font-size: 2rem;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.feature-card-button:hover {\n  background: #98daeb;\n  color: black;\n}\n\n/* Responsive card row: stack vertically on small screens */\n.feature-card-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  width: 100%;\n}\n\n@media (max-width: 700px) {\n  .feature-card-row {\n    flex-direction: column !important;\n    gap: 8px;\n    align-items: stretch !important;\n    justify-content: flex-start !important;\n    width: 100%;\n  }\n  .feature-card-col {\n    min-width: 0;\n    width: 100% !important;\n    padding: 0;\n    align-items: center;\n    justify-content: flex-start;\n  }\n  .feature-card-cover {\n    margin-bottom: 10px;\n    width: 100%;\n    max-width: 100vw;\n    min-width: 0;\n  }\n}\n\n/* ===== Card cover: full-bleed image ===== */\n.feature-card {\n  overflow: hidden; /* ensures rounded corners clip the cover */\n}\n\n.feature-card-cover {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;              /* consistent height across cards */\n  background-size: cover;\n  background-position: center;\n  border-radius: 12px;\n  margin-bottom: 14px;\n  /* box-shadow: inset 0 0 0 1px rgba(0,0,0,0.04); */\n}\n\n/* Dark-to-transparent top overlay for legibility */\n.feature-card-cover-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    180deg,\n    rgba(0,0,0,0.35) 0%,\n    rgba(0,0,0,0.15) 40%,\n    rgba(0,0,0,0.00) 100%\n  );\n  pointer-events: none;\n  border-radius: 12px;\n}\n\n/* Small badge that reuses your emoji (from the title) */\n.feature-card-badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  font-size: 1rem;\n  background: rgba(255,255,255,0.85);\n  color: #1f1f1f;\n  border-radius: 999px;\n  padding: 6px 10px;\n  line-height: 1;\n  /* box-shadow: 0 2px 8px rgba(0,0,0,0.12); */\n  backdrop-filter: saturate(140%) blur(6px);\n}\n\n/* Body spacing now that we have a cover */\n.feature-card-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Optional tiny icon fallback (hidden by default on wide screens) */\n.feature-card-image--fallback {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n  margin: 2px 0 6px 0;\n  opacity: 0.85;\n  display: none; /* only show on narrow screens via media query if desired */\n}\n\n/* Sharper highlight treatment works great with cover */\n.feature-card.highlight {\n  /* box-shadow: 0 12px 28px rgba(246, 255, 0, 0.894); */\n  /* border: 2px solid #2b8cff; */\n  transform: translateY(-2px);\n  transform: scale(1.03);\n}\n\n/* Hover polish (subtle lift & glow) */\n.feature-card:hover {\n  /* box-shadow: 0 12px 28px rgba(255, 255, 244, 0.894); */\n  transform: translateY(-2px);\n  transform: scale(1.03);\n}\n\n/* Tighter text for small screens + optional show fallback icon */\n@media (max-width: 820px) {\n  .feature-card-title { font-size: 1.05rem; }\n  .feature-card-description { font-size: 0.94rem; }\n  .feature-card-image--fallback { display: block; }\n}\n\n/* Ensure grid cards match height if lines wrap differently */\n.landing-page-features-grid > .feature-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n/* Make cards and content fit small screens */\n@media (max-width: 400px) {\n  .landing-page-container {\n    padding: 1rem 0.5rem;\n    /* max-width: 100vw;\n    width: 100vw; */\n  }\n  .feature-card {\n    margin: 1rem 0.2rem;\n    padding: 12px 4px;\n    border-radius: 10px;\n  }\n  .feature-card-title {\n    font-size: 1rem;\n  }\n  .feature-card-description {\n    font-size: 0.85rem;\n  }\n  .feature-card-button {\n    font-size: 1.2rem;\n    padding: 6px 10px;\n  }\n  .feature-card-cover {\n    aspect-ratio: 16 / 9;\n    margin-bottom: 8px;\n    border-radius: 8px;\n    width: 100%;\n    min-width: 0;\n    /* max-width: 100vw; */\n  }\n  .feature-card-row {\n    flex-direction: column;\n    gap: 4px;\n    align-items: stretch;\n    width: 100%;\n  }\n  .feature-card-col {\n    min-width: 0;\n    width: 100%;\n    padding: 0;\n  }\n  /* .landing-page-iframe {\n    width: 98vw;\n    height: 320px;\n  } */\n}\n\n.landing-page-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 800px;\n  margin-bottom: 20px;\n}\n\n.landing-page-col {\n  flex: 1;\n}\n.landing-page-col.left {\n  text-align: left;\n}\n.landing-page-col.right {\n  text-align: right;\n}\n\n.landing-page-banner {\n  width: 90%;\n  max-width: 60vw;\n  border-radius: 8px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.08);\n  display: block;\n  margin-left: auto;\n  margin-right: 0;\n}\n\n@media (max-width: 700px) {\n  .landing-page-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .landing-page-col.right {\n    width: 100%;\n    text-align: center;\n    margin-top: 16px;\n  }\n  .landing-page-banner {\n    width: 90%;\n    max-width: 350px;\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
